import React, { useContext, useEffect } from 'react'
import moment from 'moment';
import 'moment/locale/pt-br'; // Importa a localização em português para o moment
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { ToastContainer } from 'react-toastify';
import { RequestsContext } from '../../context/requests'


const CheckBox = styled.input`
    border: 1px solid black;
    width: 24px;
    height: 24px;
`

const ButtonStatus = styled.button`
    font-family: "Poppins";
    font-weight: 600;
    width: 106px;
    height: 28px;
    border: none;
    font-size: 11px;
    border-radius: 60px;

    @media screen and (max-width:820px){
        width: 100%;
        font-size: 9px;
        border-radius:50px;
        
    }


`
const TableList = ({ data, structure }) => {
    const { requests, getAll, getDashboard, handleSelectItems, setSelectItems, getById, haveRequests } = useContext(RequestsContext)

    useEffect(() => {
        getDashboard()
        getAll()
        setSelectItems([])

    }, [])

    return (
        <div className='container_startpn_table'>
            <table>

                <thead>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>


                {haveRequests == false

                    ?
                    <></>
                    :

                    <tbody>
                        {String(requests).length == 0

                            ?
                            <tr>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                                <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                            </tr>
                            :

                            requests?.map((item, index) => {
                                const dateFormated = moment(item.createdAt).format('DD/MM/YYYY');

                                return (
                                    <tr key={index}>
                                        <td><CheckBox type='checkbox' onClick={(e) => handleSelectItems(item.id, e, item.type_delivery)} /></td>
                                        <td onClick={() => getById(item.id)} >{dateFormated}</td>
                                        <td onClick={() => getById(item.id)} >#{item.id}</td>
                                        <td onClick={() => getById(item.id)} >{item.sku}</td>
                                        <td onClick={() => getById(item.id)} >{item.name_product}</td>

                                        <td  >{item.shipmentId}</td>
                                        <td  >{item.type_delivery == "1" ? <a href='https://tracken.app.br/tracken/rastreio' target='_blank'>Consultar <img style={{ width: "25px", height: "25px", marginLeft: "0.5rem" }} src={"https://www.tracken.com.br/wp-content/uploads/2023/04/tracken-api-logotipo-circular.png"} /></a> : <a href='https://www.jadlog.com.br/tracking' target='_blank' >Consultar <img style={{ width: "25px", height: "25px", marginLeft: "0.5rem" }} src={"https://play-lh.googleusercontent.com/11Du-Jx0sgP2yIYl1QMvHGG4unGUzQ__jK6pIJ2L5qgb4EUBWe_OnySoaePr1iqbueE"} /></a>}</td>
                                        <td>
                                            {item.status == null || item.status == 1

                                                ?
                                                <ButtonStatus style={{ background: "#FFF7AA", color: "#C6B200" }}>Em Aberto</ButtonStatus>
                                                :

                                                item.status == 2

                                                    ?
                                                    <ButtonStatus style={{ background: "#E0FFF0", color: "#00B386" }}>Separando</ButtonStatus>

                                                    :

                                                    item.status == 3

                                                        ?
                                                        <ButtonStatus style={{ background: "#D7DDFF", color: "#4F31F7" }}>Produzindo</ButtonStatus>
                                                        :
                                                        item.status == 4

                                                            ?

                                                            <ButtonStatus style={{ background: "#FFF898", color: "#E3A010" }}>Embalando</ButtonStatus>
                                                            :
                                                            item.status == 5

                                                                ?

                                                                <ButtonStatus style={{ background: "#A3F9D0", color: "#0A906E" }}>Enviado</ButtonStatus>

                                                                :

                                                                item.status == 6

                                                                    ?
                                                                    <ButtonStatus style={{ background: "#f73535", color: "#ffffff" }}>Cancelado</ButtonStatus>
                                                                    :

                                                                    <></>
                                            }
                                        </td>
                                    </tr>
                                )
                            })}



                    </tbody>
                }


            </table>
        </div>
    )
}

export default TableList